import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn, UserImage } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { bhk_options, landlord_property_type, listing_type, PaginationLimit } from "../../Config";
import Config from "../../Config";
import { useNavigate } from "react-router-dom";
import { Select, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import { truncateText, capitalizeFirstLetter } from "../../helpers";
import { Form, Formik } from "formik";
import { FiChevronRight, FiShare2 } from "react-icons/fi";
import Tooltip from "../Tooltip";
import { MdOutlineChevronRight } from "react-icons/md";

const UnAvailableTable = ({
  apiData,
  setViewDetail,
  setSelectedData,
  selectedData,
  setIsAddDeal,
  setIsAddTenant,
  setShowViewDeals,
  setIsLinkStaff,
  updateStatusMutate,
  getDealListMutate,
  getTenantListMutate,
  handleAssignStaff,
  selectedTab
}) => {

  const storageKey = `properties_page_index`;
  const navigate = useNavigate();
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [selectedTab]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [previousId, setPreviousId] = useState(null);
  //const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const CustomSelect = styled(Select)({
    "& .MuiSelect-icon": {
      color: "#f59e0b",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    zIndex: 0,
  });


  const viewDetails = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const addDeal = (item) => {
    setIsAddDeal(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const addTenant = (item) => {
    setIsAddTenant(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const showDeals = (item) => {
    setSelectedData(item);
    getDealListMutate(item.id);
    setOpenActionMenu(null);
  };

  const showTenants = (item) => {
    setSelectedData(item);
    getTenantListMutate(item.id);
    setOpenActionMenu(null);
  };

  const handleShare = (item) => {
    const url = `${window.location.origin}/p/${item.uniqueId}`;

    const message = `Check out this property:\n${url}`;

    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
  };

  const ActionBtns = (item) => (
    <div className="flex items-center gap-2">

      {/* Share */}
      {/* <Tooltip label="Share Property">
        <button
          onClick={() => handleShare(item)}
          className="text-gray-400 hover:text-primary-color transition bg-gray-50 hover:bg-primary-color/10 rounded-full p-1.5"
        >
          <FiShare2 size={16} />
        </button>
      </Tooltip> */}

      {/* View Details */}
      <Tooltip label="Inventory Detail">
        <button
          onClick={() => {
            navigate(`/inventory/details`, { state: { inventoryId: item?.id } })
          }}
          className="text-gray-400 hover:text-gray-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdOutlineChevronRight size={20} />
        </button>
      </Tooltip>

    </div>
  );

  useEffect(() => {
    if (apiData) {

      const tempData = apiData.map((item) => {
        if (!item) return null;

        // Base data object with safe access
        const baseData = {
          name: getName(item),
          address: getAddress(item),
          propertyType: getPropertyType(item),
          listingType: getListingType(item),
          price: getPrice(item),
          status: getStatus(item),
          action: ActionBtns(item),
          original: item
        };

        // Add tab-specific fields
        if (selectedTab === 3) {
          return {
            ...baseData,
            deals: getTenants(item),
            //notes: getNotes(item),
          };
        } else {

          return {
            ...baseData,
            deals: getDeals(item),
          };
        }
      }).filter(item => item !== null);


      setData(tempData);
    }
  }, [apiData, openActionMenu, selectedTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {

    let label = "";
    let badgeStyle = "";

    if (item?.belongsToType === Config.USER_TYPE_RETAIL.LANDLORD) {
      label = "O";
      badgeStyle = "bg-blue-100 text-blue-600";
    }
    else if (item?.belongsToType === Config.USER_TYPE_RETAIL.CHANNEL_PARTNER) {
      label = "B";
      badgeStyle = "bg-purple-100 text-purple-600";
    }

    return (
      <UserImageWrapper>
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-gray-600 text-sm font-medium">
              {item?.belongsToName
                ? item.belongsToName.charAt(0).toUpperCase() +
                item.belongsToName.slice(1)
                : "-"}
            </span>
          </div>
          <span className="text-gray-400 text-xs">
            #{item?.belongsToMobile || "-"}
          </span>
        </div>
      </UserImageWrapper>
    );
  };

  const getListingAvatar = (type) => {
    const baseStyle =
      "w-9 h-9 rounded-full flex items-center justify-center text-xs font-semibold";

    switch (type) {
      case 1:
        return (
          <div className={`${baseStyle} bg-blue-50 text-blue-600`}>
            R
          </div>
        );

      case 2:
        return (
          <div className={`${baseStyle} bg-purple-50 text-purple-600`}>
            S
          </div>
        );

      case 3:
        return (
          <div className={`${baseStyle} bg-orange-50 text-orange-600`}>
            L
          </div>
        );

      default:
        return (
          <div className={`${baseStyle} bg-neutral-100 text-gray-500`}>
            ?
          </div>
        );
    }
  };

  const getAddress = (item) => (
    <div className="flex items-center gap-3">
      {/* Listing Avatar */}
      {getListingAvatar(item?.listingType)}
      {/* <UserImage src={Images.Avatar} /> */}

      {/* Inventory Content */}
      <div className="flex flex-col gap-0.5 cursor-pointer" onClick={() =>
        navigate("/inventory/details", {
          state: { inventoryId: item?.id },
        })
      }>
        <span className="text-gray-800 text-sm font-semibold truncate max-w-[160px]">
          {capitalizeFirstLetter(item?.inventoryName || "")}
        </span>

        <span className="text-gray-400 text-xs">
          {capitalizeFirstLetter(truncateText(item.address, 28))}
        </span>
      </div>
    </div>
  );

  const getPropertyType = (item) => {

    const propertyLabel =
      landlord_property_type.find(
        (type) => type.value === item?.inventoryType
      )?.label || "-";

    const bhkOption = bhk_options.find(
      (type) => type.value === item?.inventorySubType
    );

    const bhklabel = bhkOption?.label || "";

    return (
      <div className="flex flex-col gap-1">

        <span className="px-2 py-0.5 text-xs rounded-full bg-neutral-100 text-gray-700 w-fit">
          {propertyLabel}
        </span>

        {bhklabel && bhklabel !== "Studio" && (
          <span className="text-[11px] text-gray-400">
            #{bhklabel} BHK
          </span>
        )}

        {bhklabel === "Studio" && (
          <span className="text-[11px] text-gray-400">
            #{bhklabel}
          </span>
        )}

      </div>
    );
  };

  const getListingType = (item) => {
    const listingLabel =
      listing_type.find((type) => type.value === item?.listingType)?.label ||
      "Unknown";

    return (
      <div className="flex flex-col gap-1">
        <span className="text-sm font-semibold text-gray-900">
          {listingLabel}
        </span>

        {item?.area ? (
          <span className="inline-block w-fit text-xs text-gray-500 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-md">
            #{item.area}
          </span>
        ) : (
          <span className="text-xs text-gray-400">No area</span>
        )}
      </div>
    );
  };

  const getDeals = (item) => {
    if (!item.count || item.count === 0) {
      return (
        <button
          onClick={() => addDeal(item)}
          className="px-3 py-1.5 bg-primary-color/10 hover:bg-primary-color/20 text-sm font-medium text-primary-color rounded-full inline-flex items-center gap-1 transition"
        >
          + Add Deal
        </button>
      );
    }
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => showDeals(item)}
          className="px-3 py-1.5 bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-gray-700 flex items-center gap-2 rounded-full transition"
        >
          {item.count}
          <FiChevronRight size={14} />
        </button>
      </div>
    );
  };

  const getTenants = (item) => {
    if (!item.count || item.count === 0) {
      return (
        <button
          onClick={() => addTenant(item)}
          className="px-3 py-1.5 bg-primary-color/10 hover:bg-primary-color/20 text-sm font-medium text-primary-color rounded-full inline-flex items-center gap-1 transition"
        >
          + Add Tenant
        </button>
      );
    }
    return (
      <div className="flex items-center gap-2">
        <button
          onClick={() => showTenants(item)}
          className="px-3 py-1.5 bg-neutral-100 hover:bg-neutral-200 text-sm font-medium text-gray-700 flex items-center gap-2 rounded-full transition"
        >
          {item.count}
          <FiChevronRight size={14} />
        </button>
      </div>
    );
  };

  const getPrice = (item) => {
    const listingLabel =
      listing_type.find((type) => type.value === item?.listingType)?.label;

    return (
      <div className="flex flex-col gap-1">
        {listingLabel === "Rent" && <Amount>₹{item?.monthlyRent}</Amount>}
        {listingLabel === "Sale" && <Amount>₹{item?.sellingAmount}</Amount>}
        {listingLabel === "Lease" && <Amount>₹{item?.leaseAmount}</Amount>}
      </div>
    );
  };

  const getStatus = (item) => {

    if (item.status === Config.INVENTORY_STATUS.UNAVAILABLE) {
      return (
        <Formik
          initialValues={{ status: "" }}
          onSubmit={() => { }}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <CustomSelect
                value={values.status}
                displayEmpty
                onChange={(e) => {
                  const selectedStatus = e.target.value;
                  setFieldValue("status", selectedStatus);

                  // const payload = { propId: item.id };
                  updateStatusMutate({
                    inventoryId: item.id,
                    status: selectedStatus,
                  });

                }}
                sx={{
                  "& .MuiSelect-icon": {
                    color: "#FBBF24",
                  },
                  "& .MuiOutlinedInput-input": {
                    zIndex: 0,
                  },
                }}
                variant="outlined"
                size="small"
                className="bg-yellow-50 !rounded-lg !text-yellow-500 !font-normal !text-sm !h-7"
              >
                <MenuItem value="" disabled>
                  Unavailable
                </MenuItem>
                {/* <MenuItem value={Config.INVENTORY_STATUS.AVAILABLE}>Available</MenuItem> */}
                {/* <MenuItem value={Config.INVENTORY_STATUS.CLOSED}>Closed</MenuItem> */}
                <MenuItem value={Config.INVENTORY_STATUS.AVAILABLE}>Available</MenuItem>
              </CustomSelect>
            </Form>
          )}
        </Formik>
      );
    }

    else if (item.status === Config.INVENTORY_STATUS.AVAILABLE) {
      return <Formik
        initialValues={{ status: "" }}
        onSubmit={() => { }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <CustomSelect
              value={values.status}
              displayEmpty
              onChange={(e) => {
                const selectedStatus = e.target.value;
                setFieldValue("status", selectedStatus);

                // const payload = { propId: item.id };
                updateStatusMutate({
                  inventoryId: item.id,
                  status: selectedStatus,
                });

              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#22c55e",
                },
                "& .MuiOutlinedInput-input": {
                  zIndex: 0,
                },
              }}
              variant="outlined"
              size="small"
              className="bg-green-50 !rounded-lg !text-green-500 !font-normal !text-sm !h-7"
            >
              <MenuItem value="" disabled >
                Available
              </MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.BOOKED}>Booked</MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.LEASED}>Leased</MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.UNAVAILABLE}>UnAvailable</MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.HOLD}>Hold</MenuItem>
            </CustomSelect>
          </Form>
        )}
      </Formik>;
    } else if (item.status === Config.INVENTORY_STATUS.BOOKED) {
      return <Formik
        initialValues={{ status: "" }}
        onSubmit={() => { }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <CustomSelect
              value={values.status}
              displayEmpty
              onChange={(e) => {
                const selectedStatus = e.target.value;
                setFieldValue("status", selectedStatus);

                // const payload = { propId: item.id };
                updateStatusMutate({
                  inventoryId: item.id,
                  status: selectedStatus,
                });

              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#ef4444",
                },
              }}
              variant="outlined"
              size="small"
              className="bg-red-50 !rounded-lg !text-red-500 !font-normal !text-sm !h-7"
            >
              <MenuItem value="" disabled>
                Closed
              </MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.AVAILABLE}>Available</MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.UNAVAILABLE}>UnAvailable</MenuItem>
              {/* <MenuItem value={Config.INVENTORY_STATUS.HOLD}>Hold</MenuItem> */}
            </CustomSelect>
          </Form>
        )}
      </Formik>;
    } else if (item.status === Config.INVENTORY_STATUS.LEASED) {
      return <Formik
        initialValues={{ status: "" }}
        onSubmit={() => { }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <CustomSelect
              value={values.status}
              displayEmpty
              onChange={(e) => {
                const selectedStatus = e.target.value;
                setFieldValue("status", selectedStatus);

                // const payload = { propId: item.id };
                updateStatusMutate({
                  inventoryId: item.id,
                  status: selectedStatus,
                });

              }}
              sx={{
                "& .MuiSelect-icon": {
                  color: "#3a6cf6",
                },
              }}
              variant="outlined"
              size="small"
              className="bg-blue-50 !rounded-lg !text-blue-500 !font-normal !text-sm !h-7"
            >
              <MenuItem value="" disabled>
                Leased
              </MenuItem>
              {/* <MenuItem value={Config.INVENTORY_STATUS.CLOSED}>Closed</MenuItem> */}
              <MenuItem value={Config.INVENTORY_STATUS.AVAILABLE}>Available</MenuItem>
              <MenuItem value={Config.INVENTORY_STATUS.UNAVAILABLE}>UnAvailable</MenuItem>
              {/* <MenuItem value={Config.INVENTORY_STATUS.HOLD}>Hold</MenuItem> */}
            </CustomSelect>
          </Form>
        )}
      </Formik>;
    } else {
      return "Invalid Status";
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Owner/Broker",
          accessor: "name",
        },
        {
          Header: "Status",
          accessor: "status",
        },
      ];
    }

    const cols = [
      {
        Header: "Inventory",
        accessor: "address",
      },
      {
        Header: "Owner/Broker",
        accessor: "name",
      },
      {
        Header: "Type",
        accessor: "propertyType",
      },
    ];

    // if (selectedTab !== 2 && selectedTab !== 4) {
    //   cols.push({
    //     Header: selectedTab === 3 ? "Tenants" : "Deal",
    //     accessor: "deals",
    //     id: "dealColumn",
    //   });
    // }

    cols.push(
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
        id: "actionColumn",
      }
    );

    return cols;
  }, [isMobileView, selectedTab]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  useEffect(() => {
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable key={selectedTab} {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={column.style}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        style={cell.column.style}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Address:</strong> {data[rowIndex].address}
                        </li>
                        <li>
                          <strong>Type:</strong> {data[rowIndex].propertyType}
                        </li>
                        <li>
                          <strong>Listing:</strong> {data[rowIndex].listingType}
                        </li>
                        <li>
                          <strong>Price:</strong> {data[rowIndex].price}
                        </li>
                        <li>
                          <strong>Action</strong>{" "}
                          {data[rowIndex].action}
                        </li>


                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {/* {apiData?.length === 0 && <NotFoundModel />} */}
    </>
  );
};

const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const MenuOptions = tw.div`
  absolute bottom-10 right-0
  py-2 w-max
  bg-white z-50
  rounded-xl
  shadow-xl
  border border-gray-200
  flex flex-col
`;
const MenuItemCustom = tw.div`flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50`;
const Amount = tw.p`text-gray-600 text-sm flex`

export default UnAvailableTable;
